"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getControlByPath_1 = __importDefault(require("../../ControlRenderer/utils/getControlByPath"));
const getControlPathById_1 = __importDefault(require("../../ControlRenderer/utils/getControlPathById"));
const setControlByPath_1 = __importDefault(require("../../ControlRenderer/utils/setControlByPath"));
const isMultipleListModification_1 = __importDefault(require("../../typeAssertions/isMultipleListModification"));
const evaluatePropsToModify_1 = __importDefault(require("./evaluatePropsToModify"));
const applyModifications = async ({ asyncControlUpdates, modifications, listItemControlTemplate, itemControl, controlContext, processor, controlCallerId, lastFunctionsOutputs, itemContext, }) => {
    let newItemControl = itemControl;
    const modificationEntries = Object.entries(modifications || {});
    for (let i = 0; i < modificationEntries.length; i += 1) {
        const [controlId, modification] = modificationEntries[i];
        if (!modification || (0, isMultipleListModification_1.default)(modification)) {
            continue; // eslint-disable-line
        }
        const { props: propsToModify = {}, events: eventsToAdd, } = modification;
        const controlToModifyPath = (0, getControlPathById_1.default)({
            controlId,
            rootControl: listItemControlTemplate,
        });
        if (!controlToModifyPath) {
            continue; // eslint-disable-line
        }
        const controlToModifyOriginal = (0, getControlByPath_1.default)({
            path: controlToModifyPath,
            control: newItemControl,
        });
        if (!controlToModifyOriginal) {
            console.warn('The control to modify was not found', controlToModifyPath); // eslint-disable-line
            continue; // eslint-disable-line
        }
        let controlToModify = controlToModifyOriginal;
        processor.root.setControlRunContext(controlToModify.id, controlContext);
        const evaluateEntryVar = processor
            .evaluateVarFactory({
            controlCallerId,
            lastFunctionsOutputs,
            itemContext,
        });
        controlToModify = await (0, evaluatePropsToModify_1.default)({
            asyncControlUpdates,
            propsToModify,
            evaluateEntryVar,
            initialControl: controlToModify,
        });
        if (controlToModify.isDynamicLoadingEnabled) {
            controlToModify.isDynamicLoadingEnabled = false;
        }
        // Apply events to control if they have changed
        const { events: originalEvents = [] } = controlToModify;
        if (JSON.stringify(originalEvents) !== JSON.stringify(eventsToAdd)) {
            controlToModify = Object.assign(Object.assign({}, controlToModify), { events: eventsToAdd });
        }
        const controlHasChanged = controlToModify !== controlToModifyOriginal;
        if (controlHasChanged) {
            newItemControl = (0, setControlByPath_1.default)({
                control: newItemControl,
                path: controlToModifyPath,
                controlToSet: controlToModify,
            });
        }
    }
    return newItemControl;
};
exports.default = applyModifications;
